import { FC, useContext } from 'react';

import { H2, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { IBaseModalProps } from '../interfaces';
import s from './CloudPaymentsModal.module.scss';
import { CloudPayments } from './components';

export const CloudPaymentsModal: FC<IBaseModalProps> = ({ onClose }) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
  } = useContext(SettingsContext);

  return (
    <Modal className={s.modal} onClose={onClose}>
      <div className={s.header}>
        <H2>{t('report.total.cloud_payments')}</H2>
        <span className={s.subtitle}>
          {t('settings.integration.cloudPaymentsModal.description')}
        </span>
      </div>
      <CloudPayments settings={settings} onClose={onClose} />
    </Modal>
  );
};
